import * as React from 'react'

const VPP: React.FC = () => {
  return <div>VPP displayed here</div>
}
export default VPP
